/**
 * Flattens the colour option into the drawer's chip list.
 *
 * @param {Object} param
 * @param {?Object} param.option - one of ProductOptions' `visibleOptions`
 * @param {Array} param.variantsByOptionValue - the matching parallel entry from
 *   ProductOptions. Holds `false` for combinations that make no variant.
 * @param {?string} param.selectedOptionValue
 * @returns {{optionValueName: string, materialGroup: ?string, image: ?Object,
 *   variant: ?Object, swatchProduct: ?Object, selected: boolean}[]} — a
 *   swatchProduct is {gid, handle, variantId, swatchType, price}
 */
export default function swatchDrawerItems({
  option,
  variantsByOptionValue = [],
  selectedOptionValue = null,
}) {
  if (!option) return [];

  return option.optionValues.map((optionValue) => {
    const optionVariant = (variantsByOptionValue || []).find(
      (entry) => entry && entry.optionValue === optionValue.name,
    );
    const variant = optionVariant?.variant || null;
    // Pre-flattened by unwrapNodes: a plain array of products, each with a
    // `variants` array and a string `swatchType`. Nested products get no
    // `.helpers` — addProductHelpers only decorates the top-level product.
    const swatchProduct = variant?.relatedProductsSwatches?.[0] || null;
    const swatchVariantId = swatchProduct?.variants?.[0]?.id || null;

    return {
      optionValueName: optionValue.name,
      materialGroup: optionValue.materialGroup || null,
      image:
        swatchProduct?.featuredImage ||
        optionValue.swatch?.image?.previewImage ||
        null,
      variant,
      swatchProduct:
        swatchProduct && swatchVariantId
          ? {
              gid: swatchProduct.id,
              handle: swatchProduct.handle,
              variantId: swatchVariantId,
              swatchType: swatchProduct.swatchType || null,
              price: swatchProduct.variants[0].price || null,
            }
          : null,
      selected: optionValue.name === selectedOptionValue,
    };
  });
}
